const headers = [
  {
    text: 'order.order_order-date',
    value: 'orderDate',
    width: '85px'
  },
  {
    text: 'common.input_supplier-name',
    value: 'supplierId',
    width: '115px'
  },
  {
    text: 'common.input_order-person',
    value: 'userId',
    width: '80px'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    width: '90px'
  },
  {
    text: 'sale.sale_status',
    value: 'status'
  }
]

const tableKey = 'orderId'

const productListHeaders = [
  {
    text: 'product.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '30%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'common.product_consumption-tax-rate',
    value: 'product.taxId',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '%'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'order.order_supplier-price',
    value: 'price',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '円'
  },
  {
    text: 'common.input_order-quantity',
    value: 'quantity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '円'
  }
]

const productListHeadersForEdit = [
  {
    text: 'sale.sale_status',
    value: 'product.disabledFlg',
    sortable: false,
    width: '6%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'product.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '30%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'common.product_consumption-tax-rate',
    value: 'product.taxId',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '%'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'product.product_purchase-price',
    value: 'price',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '円'
  },
  {
    text: 'common.input_order-quantity',
    value: 'quantity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'sale.sale_price',
    value: 'amount',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center',
    unit: '円'
  }
]

export default {
  headers,
  tableKey,
  productListHeaders,
  productListHeadersForEdit
}
